<template>
  <div class="mode-switch">
    <button
      v-for="it in items"
      :key="it.id"
      @click="$emit('update:mode', it.id)"
      class="mode-btn"
      :class="{ 'mode-btn--active': mode === it.id }"
    >
      <Icon :name="it.icon" :size="13" />{{ it.label }}
    </button>
  </div>
</template>

<script setup>
import Icon from './ui/Icon.vue'

defineProps({
  mode: { type: String, required: true },
})

defineEmits(['update:mode'])

const items = [
  { id: 'tarjetas', icon: 'grid',   label: 'Tarjetas' },
  { id: 'lista',    icon: 'list',   label: 'Lista densa' },
  { id: 'matriz',   icon: 'matrix', label: 'Matriz' },
]
</script>

<style scoped>
.mode-switch {
  display: inline-flex;
  padding: 3px;
  background: var(--bg);
  border-radius: 8px;
}

.mode-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  color: var(--text-2);
  font-family: var(--ff-head);
  font-weight: 600;
  font-size: 12px;
  box-shadow: none;
  transition: all 0.12s;
}

.mode-btn--active {
  background: var(--surface);
  color: var(--text);
  box-shadow: var(--shadow);
}
</style>
